
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Step1 from "@/views/pages/application/risk/steps/Step1.vue";
import Step2 from "@/views/pages/application/risk/steps/Step2.vue";
import Step3 from "@/views/pages/application/risk/steps/Step3.vue";
// import Step4 from "@/views/pages/application/risk/steps/Step4.vue";
import { StepperComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { useForm } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import router from "@/router";
import { useToast } from "vue-toastification";
import NoteSection from "@/components/sections/NoteSection.vue";

interface IStep1 {
  p1: string;
  p2: string;
  p3: string;
  p4: string;
  p5: string;
  p6: string;
  p7: string;
  p8: string;
  p9: string;
  p10: string;
  p11: string;
  p12: string;
  p13: string;
  p14: string;
  p15: string;
  p16: string;
  p17: string;
  p18: string;
  p19: string;
  p20: string;
  otherInvolvedResearch: string;
  degreeOfRisks: string;
  precautions: string;
  riskInTerms: string;
}

interface IStep2 {
  possibleBenefit: string;
}

interface IStep3 {
  includeSomething: string;
  volume: string;
  frequency: string;
  sampleDescription: string;
}

interface CreateAccount extends IStep1, IStep2, IStep3 { }

export default defineComponent({
  name: "kt-vertical-wizard",
  components: {
    Step1,
    Step2,
    Step3,
    // Step4,
    NoteSection,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const toast = useToast();

    const _stepperObj = ref<StepperComponent | null>(null);
    const verticalWizardRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(1);
    const jumped = ref(0);
    const previewStep = ref(0);
    const fromJumpled = ref(0);
    const currentRisk = computed(() => {
      return store.getters.currentRisk;
    });

    let formData = ref<CreateAccount>({
      p1:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >1 &&
          currentRisk.value.data.involvedResearch[0].isChecked
          ? "1"
          : "0",
      p2:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >2 &&
          currentRisk.value.data.involvedResearch[2].isChecked
          ? "1"
          : "0",
      p3:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >3 &&
          currentRisk.value.data.involvedResearch[3].isChecked
          ? "1"
          : "0",
      p4:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >4 &&
          currentRisk.value.data.involvedResearch[4].isChecked
          ? "1"
          : "0",
      p5:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >5 &&
          currentRisk.value.data.involvedResearch[5].isChecked
          ? "1"
          : "0",
      p6:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >6 &&
          currentRisk.value.data.involvedResearch[6].isChecked
          ? "1"
          : "0",
      p7:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >7 &&
          currentRisk.value.data.involvedResearch[7].isChecked
          ? "1"
          : "0",
      p8:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >8 &&
          currentRisk.value.data.involvedResearch[8].isChecked
          ? "1"
          : "0",
      p9:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >9 &&
          currentRisk.value.data.involvedResearch[9].isChecked
          ? "1"
          : "0",
      p10:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >10 &&
          currentRisk.value.data.involvedResearch[10].isChecked
          ? "1"
          : "0",
      p11:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >11 &&
          currentRisk.value.data.involvedResearch[11].isChecked
          ? "1"
          : "0",
      p12:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >12 &&
          currentRisk.value.data.involvedResearch[12].isChecked
          ? "1"
          : "0",
      p13:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >13 &&
          currentRisk.value.data.involvedResearch[13].isChecked
          ? "1"
          : "0",
      p14:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >14 &&
          currentRisk.value.data.involvedResearch[14].isChecked
          ? "1"
          : "0",
      p15:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >15 &&
          currentRisk.value.data.involvedResearch[15].isChecked
          ? "1"
          : "0",
      p16:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >16 &&
          currentRisk.value.data.involvedResearch[16].isChecked
          ? "1"
          : "0",
      p17:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >17 &&
          currentRisk.value.data.involvedResearch[17].isChecked
          ? "1"
          : "0",
      p18:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >18 &&
          currentRisk.value.data.involvedResearch[18].isChecked
          ? "1"
          : "0",
      p19:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >19 &&
          currentRisk.value.data.involvedResearch[19].isChecked
          ? "1"
          : "0",
      p20:
        currentRisk.value.data && currentRisk.value.data.involvedResearch!= null && currentRisk.value.data.involvedResearch.length >20 &&
          currentRisk.value.data.involvedResearch[20].isChecked
          ? "1"
          : "0",
      otherInvolvedResearch: currentRisk.value.data
        ? currentRisk.value.data.otherInvolvedResearch
        : "",
      degreeOfRisks: currentRisk.value.data
        ? currentRisk.value.data.degreeOfRisks
        : "",
      precautions: currentRisk.value.data
        ? currentRisk.value.data.precautions
        : "",
      riskInTerms: currentRisk.value.data
        ? currentRisk.value.data.riskInTerms
        : "",
      possibleBenefit: currentRisk.value.data
        ? currentRisk.value.data.possibleBenefit
        : "",
      includeSomething:
        currentRisk.value.data && currentRisk.value.data.includeSomething
          ? "1"
          : "0",
      volume: currentRisk.value.data ? currentRisk.value.data.volume : "",
      frequency: currentRisk.value.data ? currentRisk.value.data.frequency : "",
      sampleDescription: currentRisk.value.data
        ? currentRisk.value.data.sampleDescription
        : "",
    });

    onMounted(() => {
      store.dispatch(Actions.GET_IRB_APPLICATION_RISK, route.params.id);

      _stepperObj.value = StepperComponent.createInsance(
        verticalWizardRef.value as HTMLElement
      );

      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
    });

    const createAccountSchema = [
      Yup.object()
        .shape({
          p1: Yup.string(),
          p2: Yup.string(),
          p3: Yup.string(),
          p4: Yup.string(),
          p5: Yup.string(),
          p6: Yup.string(),
          p7: Yup.string(),
          p8: Yup.string(),
          p9: Yup.string(),
          p10: Yup.string(),
          p11: Yup.string(),
          p12: Yup.string(),
          p13: Yup.string(),
          p14: Yup.string(),
          p15: Yup.string(),
          p16: Yup.string(),
          p17: Yup.string(),
          p18: Yup.string(),
          p19: Yup.string(),
          p20: Yup.string(),
          otherInvolvedResearch: Yup.string().when("p19", {
            is: "1",
            then: Yup.string().required().label("Other risk"),
          }),
          degreeOfRisks: Yup.string().required().label("Degree of risk"),
          precautions: Yup.string().required().label("Precautions"),
          riskInTerms: Yup.string().required().label("Risk of terms"),
        })
        .test("riskbenefits", "", function (value) {
          const checkedCount = Object.values(value).some((val) => val === "1");
          return (
            checkedCount ||
            this.createError({
              path: "riskbenefits",
              message: "At least one must be selected",
            })
          );
        }),
      Yup.object({
        possibleBenefit: Yup.string().required().label("Advancement"),
      }),
      Yup.object({
        includeSomething: Yup.string(),
        volume: Yup.string().when("includeSomething", {
          is: "1",
          then: Yup.string().required().label("Volume"),
        }),
        frequency: Yup.string().when("includeSomething", {
          is: "1",
          then: Yup.string().required().label("Frequency"),
        }),
        sampleDescription: Yup.string().when("includeSomething", {
          is: "1",
          then: Yup.string().required().label("Sampling"),
        }),
      }),
    ];

    const currentSchema = computed(() => {
      return createAccountSchema[currentStepIndex.value - 1];
    });

    const { resetForm, handleSubmit } = useForm<IStep1 | IStep2 | IStep3>({
      validationSchema: currentSchema,
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    resetForm({
      values: {
        ...formData.value,
      },
    });

    const handleStep = handleSubmit((values) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      formData.value = {
        ...formData.value,
        ...values,
      };

      let data = currentRisk.value.data;
      const stepToUpdate =
        jumped.value === 1
          ? previewStep.value
          : fromJumpled.value == 0
            ? currentStepIndex.value - 1
            : currentStepIndex.value;
      if (stepToUpdate === 0) {
        if (data.involvedResearch == null) {
           data.involvedResearch = [];
        }
        for (var i = 0; i < 21 ; i++) {
          data.involvedResearch[i] = {value: i, isChecked: false};
        }
        data.involvedResearch[1].isChecked = formData.value.p1 == "1";
        data.involvedResearch[2].isChecked = formData.value.p2 == "1";
        data.involvedResearch[3].isChecked = formData.value.p3 == "1";
        data.involvedResearch[4].isChecked = formData.value.p4 == "1";
        data.involvedResearch[5].isChecked = formData.value.p5 == "1";
        data.involvedResearch[6].isChecked = formData.value.p6 == "1";
        data.involvedResearch[7].isChecked = formData.value.p7 == "1";
        data.involvedResearch[8].isChecked = formData.value.p8 == "1";
        data.involvedResearch[9].isChecked = formData.value.p9 == "1";
        data.involvedResearch[10].isChecked = formData.value.p10 == "1";
        data.involvedResearch[11].isChecked = formData.value.p11 == "1";
        data.involvedResearch[12].isChecked = formData.value.p12 == "1";
        data.involvedResearch[13].isChecked = formData.value.p13 == "1";
        data.involvedResearch[14].isChecked = formData.value.p14 == "1";
        data.involvedResearch[15].isChecked = formData.value.p15 == "1";
        data.involvedResearch[16].isChecked = formData.value.p16 == "1";
        data.involvedResearch[17].isChecked = formData.value.p17 == "1";
        data.involvedResearch[18].isChecked = formData.value.p18 == "1";
        data.involvedResearch[19].isChecked = formData.value.p19 == "1";
        data.involvedResearch[20].isChecked = formData.value.p20 == "1";
        data.otherInvolvedResearch = formData.value.otherInvolvedResearch;
        data.degreeOfRisks = formData.value.degreeOfRisks;
        data.precautions = formData.value.precautions;
        data.riskInTerms = formData.value.riskInTerms;
      } else if (stepToUpdate === 1) {
        data.possibleBenefit = formData.value.possibleBenefit;
      } else if (stepToUpdate === 2) {
        data.includeSomething = formData.value.includeSomething == "1";
        data.volume = formData.value.volume;
        data.frequency = formData.value.frequency;
        data.sampleDescription = formData.value.sampleDescription;
      }
      jumped.value = 0;
      fromJumpled.value = 0;
      if ([0, 1, 2, 3].indexOf(currentStepIndex.value) > -1) {
        const json = JSON.stringify(data);
        store
          .dispatch(Actions.POST_IRB_RISK, json)
          .then(() => {
            if (currentStepIndex.value === 3) {
              toast.success("Information Saved", {
                timeout: 2000
              });
              router.push({
                  name: "edit-informed-consent",
                  params: { id: route.params.id },
                });
              
            }
            currentStepIndex.value++;
            if (!_stepperObj.value) {
              return;
            }
            //_stepperObj.value.goNext();
            _stepperObj.value?.goto(currentStepIndex.value);
          })
          .catch(() => {
            toast.error(store.getters.getIrbError, {
                timeout: 2000
              });
          });
      }
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const jumpToStep = (step) => {
      jumped.value = 0;
      previewStep.value = currentStepIndex.value - 1;
      fromJumpled.value = 1;
      if (step + 1 !== currentStepIndex.value) {
        jumped.value = 1;
      }
      currentStepIndex.value = step;
      document.getElementById("buttonSubmit")?.click();
      /*if (step !== currentStepIndex.value) {
        console.log("goto step");
        currentStepIndex.value = step;
        _stepperObj.value?.goto(step + 1);
      }*/
    };

    const formSubmit = () => {
      toast.success("Information Saved", {
                timeout: 2000
              });
              window.location.reload();
      
    };

    watchEffect(() => {
      const data = store.getters.currentRisk;
      if (data === null || data.data === undefined) return;
      // if (!_stepperObj.value) {
      //   return;
      // }

      // currentStepIndex.value = 2;

      // _stepperObj.value.goto(2);
    });

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(Actions.GET_IRB_APPLICATION_RISK, route.params.id);
      }
    );

    return {
      verticalWizardRef,
      previousStep,
      handleStep,
      formSubmit,
      totalSteps,
      currentStepIndex,
      jumpToStep,
    };
  },
});
